import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { CalendarPane } from "@/pages/roadmap/components/CalendarPane";
import { EventPanel } from "@/pages/roadmap/components/EventPanel";
import { useRoadmapStore } from "@/pages/roadmap/store/roadmap-store";
import { useCursorFollower } from "@/pages/homepage/hooks/useCursorFollower";
import { Footer } from "@/components/Footer";
import type { HeaderConfig } from "@/lib/header-config";
import type { GameEvent } from "@/pages/roadmap/types";

interface RoadmapPageProps {
  onHeaderConfig: (cfg: HeaderConfig) => void;
  onHeroReady: () => void;
}

export function RoadmapPage({ onHeaderConfig, onHeroReady }: RoadmapPageProps) {
  const setEvents = useRoadmapStore((s) => s.setEvents);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Notify parent about the header configuration for this page
    onHeaderConfig({
      activeSection: "activity",
      pageTitle: "다가오는 일정",
      darkHero: false,
    });
    onHeroReady();
  }, [onHeaderConfig, onHeroReady]);

  useCursorFollower();

  const { data } = useQuery({
    queryKey: ["roadmap-events"],
    queryFn: async () => {
      const response = await api.get<GameEvent[]>("/roadmap");
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (data) {
      setEvents(data);
    }
  }, [data, setEvents]);

  return (
    <div className="min-h-screen bg-white relative font-pretendard overflow-x-hidden">
      <main className="flex min-h-screen w-full justify-start bg-white overflow-x-hidden pt-10">
        <div className="flex flex-col lg:flex-row w-full min-h-screen items-center lg:items-start justify-start lg:gap-[42px] px-6 lg:px-0">
          
          <div className="w-full lg:w-[648px] flex flex-col items-center lg:items-start justify-start pt-14 lg:pt-[180px] pb-12 lg:pb-20">
            <CalendarPane />
          </div>

          <div className="w-full lg:flex-1 flex flex-col items-stretch pb-20 lg:pt-[130px]">
            <EventPanel />
          </div>
          
        </div>
      </main>
      <Footer />
    </div>
  );
}
